import { BackIcon } from "@/components/icons/back-icon";
import { OnboardingSegmentedProgress } from "@/features/onboarding/components/onboarding-segmented-progress";

interface OnboardingTopNavProps {
  onBack: () => void;
  /** When set, shows the segmented progress bar next to the back button. */
  progressFilled?: number;
  progressTotal?: number;
  /** Hides the NutriCoach logo on the right (e.g. on the get-started screen). */
  hideLogo?: boolean;
  /** Hides the back button (e.g. on the first onboarding step). Keeps its slot to preserve layout. */
  showBack?: boolean;
}

/** Back button + optional progress bar of the dark v5 onboarding screens ("Top Nav Bar Onboarding Dark" in Figma). */
export const OnboardingTopNav = ({
  onBack,
  progressFilled,
  progressTotal,
  hideLogo = false,
  showBack = true,
}: OnboardingTopNavProps) => (
  <div className="flex items-center gap-8 pr-5 pl-5">
    {showBack ? (
      <button
        type="button"
        aria-label="Go back"
        onClick={onBack}
        className="flex size-11 shrink-0 items-center justify-center"
      >
        <BackIcon className="stroke-white" />
      </button>
    ) : (
      <div className="size-11 shrink-0" aria-hidden />
    )}
    {progressFilled !== undefined && (
      <OnboardingSegmentedProgress
        filled={progressFilled}
        total={progressTotal}
        className="max-w-[225px]"
      />
    )}
    {!hideLogo && <img src="assets/images/nc-logo-new-small.svg" />}
  </div>
);
